import Avvvatars from "avvvatars-react";
import { useState } from "react";
import { CustomAvatar, parseCustomAvatar } from "./CustomAvatar";

export const UserAvatar = ({
  src,
  className,
  alt,
  value,
  size = 32,
}: {
  src?: string | null;
  className?: string;
  alt?: string;
  value?: string;
  size?: number;
}) => {
  const [isImageError, setIsImageError] = useState(false);
  if (src && src !== "" && !isImageError) {
    return (
      <img
        src={src}
        className={`${className ?? ""} object-cover object-center`}
        alt={alt}
        onError={() => setIsImageError(true)}
      />
    );
  }

  const custom = parseCustomAvatar(value);
  if (custom) {
    return (
      <div className={`${className ?? ""} overflow-hidden flex-shrink-0`}>
        <CustomAvatar
          shapeKey={custom.shapeKey}
          colorIndex={custom.colorIndex}
          size={size}
        />
      </div>
    );
  }

  return (
    <div className={`${className ?? ""} overflow-hidden flex-shrink-0`}>
      <Avvvatars
        value={value || alt || "?"}
        style="shape"
        size={size}
        radius={0}
      />
    </div>
  );
};
